/** @jsxFrag React.Fragment */
import * as React from 'react';

import { FormattedHTMLMessage } from 'js/lib/coursera.react-intl';

import _t from 'i18n!nls/authentication';

export const HEADER_HEIGHT_PX = 55;

export const AUTH_MODES_WITH_SINGLE_PAGE = {
  signup: 'signup',
  login: 'login',
} as const;

const EMAIL = 'email';
const PASSWORD = 'password';
const FULLNAME = 'name';

const tokenCodes = {
  GOOD_TOKEN: 'good',
  INVALID_TOKEN: 'invalid',
  EXPIRED_TOKEN: 'expired',
  ALREADY_VERIFIED: 'already-verified',
  IS_VERIFYING: 'is-verifying',
};

export const { GOOD_TOKEN, INVALID_TOKEN, EXPIRED_TOKEN, ALREADY_VERIFIED, IS_VERIFYING } = tokenCodes;

export const emailResponseStatusToError = {
  [GOOD_TOKEN]: (email: string) =>
    email && (
      <FormattedHTMLMessage
        message={_t('Your email address <strong>{email}</strong> is verified. Thank you!')}
        email={email}
      />
    ),
  [INVALID_TOKEN]: () => _t('Sorry, your verification token is invalid.'),
  [EXPIRED_TOKEN]: () =>
    _t(
      'Sorry, your verification token expired. We resent you the verification email. Please use the link in the email to verify.'
    ),
  [ALREADY_VERIFIED]: () => _t('Your email address has already been verified. Thank you!'),
};

export default {
  tokenCodes,
  emailResponseStatusToError,
};

/* Start errors caught from BE: https://docs.google.com/spreadsheets/d/1YLMQa0o8dBDqRLxs1sHrjTWjjxC5ju8UaASC55SjANk/edit */
const recaptchaFailed = 'recaptchaFailed';
const tooManyRequests = 'tooManyRequests';

/**
 * Authentication form variant types used to determine which authentication
 * method to display in the authentication modal/flow.
 */
export const AUTHENTICATION_FORM_VARIANTS = {
  /** Traditional email/password authentication form */
  PASSWORD: 'password',
  /** Generic authentication form (fallback/default) */
  GENERIC: 'generic',
  /** Social media and Single Sign-On authentication options */
  SOCIALSSO: 'socialsso',
} as const;

export type AUTHENTICATION_FORM_VARIANTS_KEY =
  (typeof AUTHENTICATION_FORM_VARIANTS)[keyof typeof AUTHENTICATION_FORM_VARIANTS];

// SSO Banner Names for tracking
export const SSO_BANNER_NAMES = {
  SOCIAL_LOGIN: 'sso_enforced_via_social_login_banner',
  PASSWORD_LOGIN: 'sso_enforced_via_password_banner',
} as const;

export type SsoBannerName = (typeof SSO_BANNER_NAMES)[keyof typeof SSO_BANNER_NAMES];

export { recaptchaFailed, tooManyRequests, EMAIL, PASSWORD, FULLNAME };
